import React from "react";
import ReactGA from "react-ga";

import Form from "./pages/Form";
import Verify from "./pages/Verify";

import "react-lineicons";
import "bootstrap/dist/css/bootstrap.css";
import "./App.scss";

class App extends React.Component {

    route = Form;
    match = {};

    constructor(props) {
        super(props);

        let match = window.location.pathname.match(/\/de\/([0-9]+)\/([A-Za-z0-9]+)\/?/);
        if (match) {
            this.route = Verify;
            this.match.params = {
                listingId: match[1],
                token: match[2]
            };
        }
    }

    componentDidMount() {
        ReactGA.initialize("UA-43109499-1");
        ReactGA.pageview(window.location.pathname + window.location.search);
        ReactGA.event({
            category: 'Form',
            action: 'Form loaded'
        });
    }

    render() {
        return (
            <this.route match={this.match} ga={ReactGA}/>
        );
    }
}

export default App;
